import { __extends } from "tslib";
import { StartDocumentTextDetectionRequest, StartDocumentTextDetectionResponse } from "../models/models_0";
import { deserializeAws_json1_1StartDocumentTextDetectionCommand, serializeAws_json1_1StartDocumentTextDetectionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartDocumentTextDetectionCommand = /** @class */ (function (_super) {
    __extends(StartDocumentTextDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartDocumentTextDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartDocumentTextDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "TextractClient";
        var commandName = "StartDocumentTextDetectionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: StartDocumentTextDetectionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartDocumentTextDetectionResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartDocumentTextDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartDocumentTextDetectionCommand(input, context);
    };
    StartDocumentTextDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartDocumentTextDetectionCommand(output, context);
    };
    return StartDocumentTextDetectionCommand;
}($Command));
export { StartDocumentTextDetectionCommand };
//# sourceMappingURL=StartDocumentTextDetectionCommand.js.map